import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { AssessmentDetails } from "Assessments";
import ClassRoomDetails from "ClassRoom/routes/ClassRoomDetails";

export default store => ({
  path: "timetable",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "course-studentPortfolio-timetable" */ "../ProfileSection/components/TimeTable"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ClassRoomDetails(store), AssessmentDetails(store)],
});
